module.exports = __webpack_public_path__ + "img/restaurantinnen.b38a146a.jpg";